<template>
  <div class="airalo_order">
    <div class="response_table">
      <div class="summary card" v-if="summary.length > 0">
        <p v-for="(sum, key) in summary" :key="key">
          <span>{{ translate("airalo.summary." + sum.name) }}:</span>
          <span v-html="sum.value" />
        </p>
      </div>
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th scope="col">
              {{ translate('airalo.code') }}
            </th>
            <th scope="col">
              {{ translate('airalo.date') }}
            </th>
            <th scope="col">
              {{ translate('airalo.type') }}
            </th>
            <th scope="col">
              {{ translate('airalo.package_id') }}
            </th>
            <th scope="col">
              {{ translate('airalo.price') }}
            </th>
            <th scope="col">
              {{ translate('airalo.net_price') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(airalo_order, key) in airalo_order_list" :key="key" class="currency">
            <td :data-label="translate('airalo.code')">
              {{ airalo_order.code }}
            </td>
            <td :data-label="translate('airalo.date')">
              {{ airalo_order.date }}
            </td>
            <td :data-label="translate('airalo.type')">
              {{ airalo_order.type }}
            </td>
            <td :data-label="translate('airalo.package_id')">
              {{ airalo_order.package_id }}
            </td>
            <td :data-label="translate('airalo.price')">
              {{ airalo_order.price }}
            </td>
            <td :data-label="translate('airalo.net_price')">
              {{ airalo_order.net_price }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: 'CurrencyRate',
  components: {
    WrapDatePicker,
  },
  data () {
    return {
      airalo_order_list: [],
      summary: []
    }
  },

  created () {
    this.load_airalo_order()
  },

  methods: {
    load_airalo_order(){
      this.$http.simcard.getAiraloOrders({}, (response) => {
        if (response.data){
          this.airalo_order_list = response.data.data
          this.summary = response.data.summary
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.airalo_order{
  height: 100%;
  .response_table{
    padding: 0;
  }
  .currency{
    cursor: pointer;
    &:hover{
      background-color: #eee;
    }
    td{
      overflow: hidden;
    }
    .value{
      text-align: right;
      padding-right: 20px;
    }
  }
}
</style>
